/**
 * Shows the selected variant's glass privacy rating (see snippets/privacy-rating.liquid).
 * Ratings are "<level> – <name>", e.g. "4 – High".
 */
if (!customElements.get("privacy-rating")) {
  class PrivacyRating extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('[type="application/json"]');
      this.ratings = dataEl ? JSON.parse(dataEl.textContent) : {};
      this.section = this.closest(".js-product") || document;
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.section.addEventListener("on:variant:change", this.handleVariantChange);
    }

    disconnectedCallback() {
      this.section.removeEventListener("on:variant:change", this.handleVariantChange);
    }

    /**
     * Handles 'on:variant:change' events from the variant picker.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      const variant = evt.detail && evt.detail.variant;
      this.update(variant ? this.ratings[variant.id] : null);
    }

    /**
     * Updates the scale, or hides it when the variant has no rating.
     * @param {?string} value - Metafield value, e.g. "4 – High".
     */
    update(value) {
      const level = value ? parseInt(value, 10) : NaN;
      if (!(level >= 1 && level <= 5)) {
        this.hidden = true;
        return;
      }

      this.querySelector(".privacy-rating__name").textContent = value
        .replace(/^\s*\d+\s*[–-]?\s*/, "");
      this.querySelector(".privacy-rating__level").textContent =
        this.dataset.levelText.replace("[level]", level);
      this.querySelectorAll(".segment-bar__segment").forEach((el, index) => {
        el.classList.toggle("segment-bar__segment--filled", index < level);
      });
      this.hidden = false;
    }
  }

  customElements.define("privacy-rating", PrivacyRating);
}
